import HorizontalLogo from 'components/horizontal-logo/horizontal-logo.component';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { selectClientName } from 'redux/config/config.selectors';
import { LogoLinkContainer } from './header.styles';

const HeaderLogoLink = () => {
  const clientName = useSelector(selectClientName);
  const { t } = useTranslation();

  return (
    <LogoLinkContainer>
      <Link to="/" data-testid="Header.Container.ToolbarWrapper.LogoLink">
        <HorizontalLogo alt={t('header.logo.link.linkAlt', { clientName })} />
      </Link>
    </LogoLinkContainer>
  );
};
export default HeaderLogoLink;
